<template>
  <div>
    <v-text-field
      outlined
      :rules="isItRequired"
      :label="generateLabel"
      @change="handleTextChange"
      :value="value || field.default"
      :disabled="isDisabled"
      :counter="hasLimit ? limit : null"
      :maxlength="hasLimit ? limit : null"
      dense
      :hint="field.hint"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HTML5Phone",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Object],
      default: "",
    },
  },
  data: () => ({
    limit: 0,
    unsubscribe: null,
  }),
  computed: {
    ...mapState({
      currentFlow: (state) => state.company.currentFlow,
    }),
    isItRequired() {
      return this.field.element_required || this.field.required
        ? [this.validation.required, this.validation.onlyNumbers]
        : [this.validation.onlyNumbers];
    },
    generateLabel() {
      return this.field.element_required || this.field.required
        ? `${this.field.published_name}*`
        : this.field.published_name;
    },
    hasLimit() {
      return (
        this.field.character_limit &&
        this.field.character_limit.length &&
        this.field.character_limit !== "0"
      );
    },
    isDisabled() {
      if (this.field.protected) {
        return true;
      }
      return false;
    },
  },
  created() {
    if (this.hasLimit) {
      this.limit = parseInt(this.field.character_limit);
    }
    if (this.field.default) {
      this.handleTextChange(this.field.default);
    }
    if (this.field.conditional_visibility) {
      this.handleConditionalVisibility();
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  methods: {
    handleConditionalVisibility() {
      if (!this.field.conditional_visibility_values) return;
      const controllerField = this.currentFlow.config.payload_config.root_elements.find(
        (field) =>
          field.published_name === this.field.conditional_visibility_input
      );
      this.subscribeToMasterFieldChanges(controllerField);
    },
    subscribeToMasterFieldChanges(controlField) {
      this.unsubscribe = this.$store.subscribe((mutation) => {
        if (mutation.type === "company/setFlowData") {
          const controlFieldKey = controlField.key;
          if (
            !Object.prototype.hasOwnProperty.call(
              mutation.payload,
              controlFieldKey
            )
          )
            return;
          const value = mutation.payload[controlFieldKey];
          if (this.field.conditional_visibility_values.includes(value)) {
            this.$emit("manage-field-visibility", {
              visibility: false,
              field: this.field.key,
            });
            return;
          }
          this.$emit("manage-field-visibility", {
            visibility: true,
            field: this.field.key,
          });
        }
      });
    },
    handleTextChange(value) {
      this.$emit("text-change", {
        [this.field.key]: value.replace(/[^0-9]/gi, ""),
      });
    },
  },
};
</script>
